import React from 'react'
let PropTypes = React.PropTypes

import * as css from './PanelAuditoria.css'
// Componentes
import HeaderConFiltro from '../../components/shared/HeaderConFiltro.jsx'
import { RowIRD, RowVencimiento, RowNoEncontrado } from './RowCaptura.jsx'
import { FormularioAgregarCapturas } from './FormularioAgregarCapturas.jsx'

export class TablaIRD extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
        this.publicarAuditoriaIrd = ()=>{
            this.context.publicarAuditoriaIrd()
        }
    }
    render() {
        let totalCapturas = this.props.capturaIRDFiltrada.length
        return (
            <div>
                <div className="col-md-6">
                    <div className="col-md-5">
                        <h4>Captura IRD</h4>
                    </div>
                    <div className="col-md-1">
                        {!this.props.fcv ? <button className={this.props.revisado? "btn btn-xs btn-danger "+css.btnPublicar : "btn btn-xs btn-success "+css.btnPublicar}
                                onClick={this.publicarAuditoriaIrd}
                        >
                            <span className={this.props.revisado? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file"}></span>
                            {this.props.revisado? " Despublicar" : " Publicar"}
                        </button> : null}
                    </div>
                </div>          
                <TablaCapturaIRD 
                    filtros={this.props.filtros} 
                    actualizarFiltro={this.props.actualizarFiltro}
                >
                    {_.range(0, totalCapturas).map(index=>{
                        let capturaIRD = this.props.capturaIRDFiltrada[index]
                            return <RowIRD
                                key={index}
                                index={index}
                                capturaIRD={capturaIRD}
                                fcv={this.props.fcv}
                            />
                    })}
                </TablaCapturaIRD>
            </div>
        )
    }
}
TablaIRD.contextTypes = {
    publicarAuditoriaIrd: PropTypes.func
}
let TablaCapturaIRD = ({filtros, actualizarFiltro, children}) =>
    <table className={"table table-bordered table-condensed "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colModificaciones}/>
            <col className={css.colSku}/>
            <col className={css.colBarra}/>
            <col className={css.colDescriptor}/>
            <col className={css.colLaboratorio}/>
            <col className={css.colItems}/>
            <col className={css.colTotalConteo}/>
            <col className={css.colTotalConteo}/>
            <col className={css.colStock}/>
            <col className={css.colStock}/>
            <col className={css.colTeorico}/>
            <col className={css.colSinRespaldo}/>
            <col className={css.colEliminar}/>
        </colgroup>
        <thead>
            <tr>
                <th className={css.thIndex}>#</th>
                <th className={css.thModificaciones}>
                    <HeaderConFiltro
                        nombre=''
                        filtro={filtros.filtroCritico || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroCritico')}
                    />
                </th>
                <th className={css.thSku}>
                    <HeaderConFiltro
                        nombre='SKU'
                        filtro={filtros.filtroSKU || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroSKU')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thBarra}>
                    <HeaderConFiltro
                        nombre='Barra'
                        filtro={filtros.filtroBarra || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroBarra')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thDescriptor}>
                    <HeaderConFiltro
                        nombre='Descriptor'
                        filtro={filtros.filtroDescriptor || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroDescriptor')}
                        busquedaExacta={true}
                    />                        
                </th>
                <th className={css.thLaboratorio}>
                    <HeaderConFiltro
                        nombre='Laboratorio'
                        filtro={filtros.filtroLaboratorio || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroLaboratorio')}
                        busquedaExacta={true}
                    />                           
                </th>
                <th className={css.thItems}>
                    <HeaderConFiltro
                        nombre='Items'
                        filtro={filtros.filtroItems || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroItems')}
                        busquedaExacta={true}
                    />  
                </th>
                <th className={css.thTotalConteo}>
                    <HeaderConFiltro
                        nombre='Físico'
                        filtro={filtros.filtroTotalConteo || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroTotalConteo')}
                        busquedaExacta={true}
                    />   
                </th>
                <th className={css.thTotalConteo}>Link</th>
                <th className={css.thStock}>
                    <HeaderConFiltro
                        nombre='Pantalla'
                        filtro={filtros.filtroStock || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroStock')}
                        busquedaExacta={true}
                    />   
                </th>
                <th className={css.thStock}>Pantalla</th>
                <th className={css.thTeorico}>
                    <HeaderConFiltro
                        nombre='Dif.'
                        filtro={filtros.filtroDiferencia || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroDiferencia')}
                        busquedaExacta={true}
                    />   
                </th>
                <th className={css.thSinRespaldo}>Sin Respaldo</th>
                <th className={css.thEliminar}/>
            </tr>
        </thead>
        <tbody>
            {children}
        </tbody>
    </table>
export class TablaVencimiento extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
        this.eliminarCaptura = ()=>{
            this.context.eliminarCaptura()
        }
        this.eliminarCapturaDefinitivo = ()=>{
            this.context.eliminarCapturaDefinitivo()
        }
        this.restaurarCaptura = ()=>{
            this.context.restaurarCaptura()
        }
        this.publicarAuditoriaVencimiento = ()=>{
            this.context.publicarAuditoriaVencimiento()
        }
    }
    render() {
        let totalCapturas = this.props.capturaVencimientoFiltrada.length
        return (
            <div>
                <div className="col-md-6">
                    <div className="col-md-5">
                        <h4>Captura Vencimiento</h4>
                    </div>
                    <div className="col-md-1">
                        {!this.props.fcv ? <button className={this.props.revisado? "btn btn-xs btn-danger "+css.btnPublicar : "btn btn-xs btn-success "+css.btnPublicar}
                                onClick={this.publicarAuditoriaVencimiento}
                        >
                            <span className={this.props.revisado? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file"}></span>
                            {this.props.revisado? " Despublicar" : " Publicar"}
                        </button> : null}
                    </div>
                </div>
                <div className="col-md-6">
                    {!this.props.fcv ? <button className={"btn btn-xs btn-info pull-right "+css.btnEstadosCaptura} onClick={this.restaurarCaptura} disabled={this.props.estado_vencimiento === 1}><span className={"glyphicon glyphicon-share-alt "+css.iconoEspejo}></span> Restaurar Todas</button> : null}
                    {!this.props.fcv ? <button className={"btn btn-xs btn-warning pull-right "+css.btnEstadosCaptura} onClick={this.eliminarCaptura} disabled={this.props.estado_vencimiento === 3}><span className="glyphicon glyphicon-ban-circle"></span> Deshabilitar Todas</button> : null}
                    {!this.props.fcv ? <button className={"btn btn-xs btn-danger pull-right "+css.btnEstadosCaptura} onClick={this.eliminarCapturaDefinitivo} disabled={true}><span className="glyphicon glyphicon-remove"></span> Eliminar Todas</button> : null}
                    {!this.props.fcv ? <FormularioAgregarCapturas
                        puedeAgregar={true}
                        idAuditoria={this.props.idAuditoria}
                        idArchivoFinalAuditoria={this.props.idArchivoFinalAuditoria}
                    >    
                    </FormularioAgregarCapturas> : null}
                </div>
                <TablaCapturaVencimiento 
                    filtros={this.props.filtros} 
                    actualizarFiltro={this.props.actualizarFiltro}
                >
                    {_.range(0, totalCapturas).map(index=>{
                        let capturaVencimiento = this.props.capturaVencimientoFiltrada[index]
                            return <RowVencimiento
                                key={index}
                                index={index}
                                capturaVencimiento={capturaVencimiento}
                                local={this.props.local}
                                auditor={this.props.auditor}
                                fcv={this.props.fcv}
                            />
                    })}
                </TablaCapturaVencimiento>
            </div>
        )
    }
}
TablaVencimiento.contextTypes = {
    eliminarCaptura: PropTypes.func,
    eliminarCapturaDefinitivo: PropTypes.func,
    restaurarCaptura: PropTypes.func,
    publicarAuditoriaVencimiento: PropTypes.func,
    pegarCapturasVencimiento: PropTypes.func
}
let TablaCapturaVencimiento = ({filtros, actualizarFiltro, children}) =>
    <table className={"table table-bordered table-condensed "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colModificaciones}/>
            <col className={css.colSku}/>
            <col className={css.colBarra}/>
            <col className={css.colDescriptor}/>
            <col className={css.colLaboratorio}/>
            <col className={css.colVendedor}/>
            <col className={css.colItems}/>
            <col className={css.colLote}/>
            <col className={css.colFechExp}/>
            <col className={css.colVencido}/>
            <col className={css.colPolitica}/>
            <col className={css.colMalEnfocado}/>
            <col className={css.colMalEnfocado}/>
            <col className={css.colImagen}/>
            <col className={css.colEliminar}/>
        </colgroup>
        <thead>
            <tr>
                <th className={css.thIndex}>#</th>
                <th className={css.thModificaciones}>
                    <HeaderConFiltro
                        nombre=''
                        filtro={filtros.filtroCritico || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroCritico')}
                    />
                </th>
                <th className={css.thSku}>
                    <HeaderConFiltro
                        nombre='SKU'
                        filtro={filtros.filtroSKU || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroSKU')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thBarra}>
                    <HeaderConFiltro
                        nombre='Barra'
                        filtro={filtros.filtroBarra || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroBarra')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thDescriptor}>
                    <HeaderConFiltro
                        nombre='Descriptor'
                        filtro={filtros.filtroDescriptor || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroDescriptor')}
                        busquedaExacta={true}
                    />  
                </th>
                <th className={css.thLaboratorio}>
                    <HeaderConFiltro
                        nombre='Laboratorio'
                        filtro={filtros.filtroLaboratorio || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroLaboratorio')}
                        busquedaExacta={true}
                    />                           
                </th>
                <th className={css.thVendedor}>
                    <HeaderConFiltro
                        nombre='Vendedor'
                        filtro={filtros.filtroVendedor || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroVendedor')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thItems}>
                    <HeaderConFiltro
                        nombre='Items'
                        filtro={filtros.filtroItems || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroItems')}
                        busquedaExacta={true}
                    />  
                </th>
                <th className={css.thLote}>
                    <HeaderConFiltro
                        nombre='Lote'
                        filtro={filtros.filtroLote || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroLote')}
                        busquedaExacta={true}
                    />  
                </th>
                <th className={css.thFechExp}>
                    <HeaderConFiltro
                        nombre='Fecha. Venc.'
                        filtro={filtros.filtroFechaVencimiento || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroFechaVencimiento')}
                        busquedaExacta={true}
                    />  
                </th>
                <th className={css.thVencido}>
                    <HeaderConFiltro
                        nombre='Venc.'
                        filtro={filtros.filtroVencido || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroVencido')}
                        busquedaExacta={true}
                    /> 
                </th>
                <th className={css.thPolitica}>
                    <HeaderConFiltro
                        nombre='Pol.'
                        filtro={filtros.filtroVencidoPolitica || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroVencidoPolitica')}
                        busquedaExacta={true}
                    /> 
                </th>
                <th className={css.thMalEnfocado}>
                    <HeaderConFiltro
                        nombre='SR'
                        filtro={filtros.filtroMalEnfocado || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroMalEnfocado')}
                        busquedaExacta={true}
                    /> 
                </th>
                <th className={css.thMalEnfocado}>
                    <HeaderConFiltro
                        nombre='SV'
                        filtro={filtros.filtroNoMedible || []}
                        actualizarFiltro={actualizarFiltro.bind(this, 'filtroNoMedible')}
                        busquedaExacta={true}
                    />
                </th>
                <th className={css.thImagen}>Ver</th>
                <th className={css.thEliminar}/>
            </tr>
        </thead>
        <tbody>
            {children}
        </tbody>
    </table>
export class TablaNoEncontrados extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
        this.publicarAuditoriaNoEncontrados = ()=>{
            this.context.publicarAuditoriaNoEncontrados()
        }    
    }
    render() {
        let totalCapturas = this.props.capturaNoEncontradosFiltrada.length
        return (
            <div>
                <div className="col-md-9">
                    <div className="col-md-7">
                        <h4>Productos NO encontrados en auditoría vencimiento</h4>
                    </div>
                    <div className="col-md-1">
                        {!this.props.fcv ? <button className={this.props.revisado? "btn btn-xs btn-danger "+css.btnPublicar : "btn btn-xs btn-success "+css.btnPublicar}
                                onClick={this.publicarAuditoriaNoEncontrados}
                        >
                            <span className={this.props.revisado? "glyphicon glyphicon-save-file" : "glyphicon glyphicon-open-file"}></span>
                            {this.props.revisado? " Despublicar" : " Publicar"}
                        </button> : null}
                    </div>
                </div>
                <TablaCapturaNoEncontrados
                    filtros={this.props.filtros}
                    actualizarFiltro={this.props.actualizarFiltro}
                >
                    {_.range(0, totalCapturas).map(index=>{
                        let capturaNoEncontrado = this.props.capturaNoEncontradosFiltrada[index]
                        return <RowNoEncontrado
                            key={index}
                            index={index}
                            capturaNoEncontrado={capturaNoEncontrado}
                            local={this.props.local}
                            auditor={this.props.auditor}
                            fcv={this.props.fcv}
                        />
                    })}
                </TablaCapturaNoEncontrados>
            </div>
        )
    }
}
TablaNoEncontrados.contextTypes = {
    eliminarCaptura: PropTypes.func,
    restaurarCaptura: PropTypes.func,
    publicarAuditoriaNoEncontrados: PropTypes.func
}
let TablaCapturaNoEncontrados = ({filtros, actualizarFiltro, children}) =>
    <table className={"table table-bordered table-condensed "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colModificaciones}/>
            <col className={css.colSku}/>
            <col className={css.colDescriptor}/>
            <col className={css.colLaboratorio}/>
            {/*cod_vendedor*/}
            <col className={css.colSku}/>
            {/*estado*/}
            <col className={css.colVencido}/>
            {/*stock*/}
            <col className={css.colStockNo}/>
            <col className={css.colImagen}/>
            <col className={css.colBorrosa}/>
            <col className={css.colEliminar}/>
        </colgroup>
        <thead>
        <tr>
            <th className={css.thIndex}>#</th>
            <th className={css.thModificaciones}></th>
            <th className={css.thSku}>
                <HeaderConFiltro
                    nombre='SKU'
                    filtro={filtros.filtroSKU || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroSKU')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thDescriptor}>Descriptor</th>
            <th className={css.thLaboratorio}>Laboratorio</th>
            <th className={css.thSku}>
                <HeaderConFiltro
                    nombre='Vendedor'
                    filtro={filtros.filtroVendedor || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroVendedor')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thVencido}>Estado</th>
            <th className={css.thStockNo}>Stock</th>
            <th className={css.thImagen}>Ver</th>
            <th className={css.thBorrosa}>Desenfocada</th>
            <th className={css.thEliminar}/>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/TablaCaptura.jsx